import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { audioList } from '../api/audio';
import './AudioPlaylists.scss';

export default function AudioByDevicesList() {
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(false);
    const [q, setQ] = useState('');

    useEffect(() => { load(); }, []);
    async function load() {
        setLoading(true);
        try { setItems(await audioList()); }
        catch (e) { alert(e.message || 'Ошибка загрузки'); }
        finally { setLoading(false); }
    }

    const filtered = items.filter(a => {
        const s = `${a.filename || ''} ${a.hash || ''}`.toLowerCase();
        return s.includes(q.toLowerCase());
    });

    return (
        <div className="a-pl-list">
            <div className="head">
                <h2>Аудио по устройствам</h2>
                <div className="create">
                    <input
                        placeholder="Поиск по имени/хэшу"
                        value={q}
                        onChange={e=>setQ(e.target.value)}
                    />
                    <button className="btn" onClick={load} disabled={loading}>
                        {loading ? 'Обновляю...' : 'Обновить'}
                    </button>
                </div>
            </div>

            {loading ? <div className="loading">Загрузка...</div> : (
                <div className="grid">
                    {filtered.length === 0 ? <div className="empty">Нет аудиофайлов</div> :
                        filtered.map(a => (
                            <div key={a.id} className="card">
                                <div className="title">{a.filename || `#${a.id}`}</div>
                                <div className="meta">
                                    <span>id: {a.id}</span>
                                    <span>size: {a.size ? (a.size/1024/1024).toFixed(2) : '0.00'} MB</span>
                                </div>
                                <div className="actions">
                                    <Link to={`/audio-devices/${a.id}`} className="btn">Настроить устройства</Link>
                                </div>
                            </div>
                        ))
                    }
                </div>
            )}
        </div>
    );
}
